/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import {StatusBarContainer} from '../../../components/StatusBar';
import * as S from './styles';
import {RootState} from '../../../store';
import {useSelector} from 'react-redux';
import {ActivityIndicator, FlatList} from 'react-native';
import {toPrice} from '../../../utils/functions';
import Button from '../../../components/Button';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {getTokens} from '../../../services/tokens';

export default function TokensScreen() {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const navigation: any = useNavigation();
  const focus = useIsFocused();

  const [page, setPage] = useState(1);
  const [qtdPages, setQtdPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [listTokens, setListTokens] = useState<Array<any>>([]);

  const getListToken = async () => {
    try {
      setIsLoading(true);
      const response = await getTokens(
        userInfo?.user?.id,
        page,
        10,
        userInfo?.token,
      );
      setIsLoading(false);
      setQtdPages(response?.result?.qtdPages || 1);
      setListTokens(response?.result?.list || []);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (focus) {
      const timeoutId = setTimeout(() => {
        getListToken();
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [page, focus]);

  function onEndReached() {
    if (page < qtdPages) {
      setPage(page + 1);
    }
  }

  const renderItemToken = ({item}: any) => {
    return (
      <S.Item>
        <S.Row>
          <S.ImageToken
            source={{
              uri: item?.token?.logo || '',
            }}
            resizeMode="contain"
          />
          <S.Column>
            <TextDefault
              fontSize={14}
              color={theme.colors(appTheme).white}
              text={item?.token?.name || ''}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
            <TextDefault
              fontSize={10}
              color={theme.colors(appTheme).white}
              text={`Qtd. ${item.total_qtd || ''}`}
              marginTop={5}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
          </S.Column>
        </S.Row>
        <S.Column style={{alignItems: 'flex-end'}}>
          {/* <TextDefault
            fontSize={14}
            color={theme.colors(appTheme).green[900]}
            text={`${item.percentage}%`}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          /> */}
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={`Valor unitário: R$ ${toPrice(
              item.total_value / item.total_qtd,
              3,
            )}`}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={`Valor total: R$ ${toPrice(item.total_value || 0, 2)}`}
            marginTop={5}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Column>
      </S.Item>
    );
  };

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <S.HeaderList>
            <TextDefault
              fontSize={18}
              color={theme.colors(appTheme).white}
              text="Meus tokens"
              fontFamily={theme.fonts.family.opensans.semi_bold}
              textAlign="center"
            />
            <Button
              title="FAZER OFERTA"
              onPress={() => navigation.navigate('GavelScreen')}
              fontFamily={theme.fonts.family.opensans.bold}
              width={120}
            />
          </S.HeaderList>
          {isLoading ? (
            <ActivityIndicator
              size="large"
              color={theme.colors(appTheme).white}
              style={{marginTop: 40}}
            />
          ) : (
            <FlatList
              data={listTokens}
              renderItem={renderItemToken}
              keyExtractor={item => String(item?.id)}
              style={{width: '100%'}}
              contentContainerStyle={{paddingBottom: 60, paddingTop: 20}}
              indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
              onEndReached={onEndReached}
              onEndReachedThreshold={0.3}
            />
          )}
        </S.ContainerArea>
      </S.Container>
    </>
  );
}
